import angular from 'angular';

const inputDimensionsDirective = /* @ngInject */ () => ({
	scope:    {
		disabled: '=?ngDisabled',
		model:    '=ngModel',
		required: '=?ngRequired',
	},
	require:  'ngModel',
	restrict: 'E',
	template: `
<div class="directive-input-dimensions" ng-class="{'has-error': customError}">
	<div class="input-group input-group-sm">
		<input type="number" class="form-control" size="3" min="0" ng-model="width"
			ng-required="required" ng-disabled="disabled">
		<span class="input-group-addon">
			<i class="fa fa-times"></i>
		</span>
		<input type="number" class="form-control" size="3" min="0" ng-model="height"
			ng-required="required" ng-disabled="disabled">
	</div>
	<div ng-show="customError">
		<p class="help-block">{{ customError }}</p>
	</div>
</div>
`,
	/**
	 * @param {any} scope
	 * @param {any} element
	 * @param {any} attributes
	 * @param {import('angular').INgModelController | undefined} ngModel
	 */
	link(scope, element, attributes, ngModel) {
		// format text going to user (model to view)
		ngModel?.$formatters.push(value => {
			if (angular.isString(value)) {
				const r = /^(\d+)[*x](\d+)$/.exec(value);
				if (r) {
					[, scope.width, scope.height] = r;
				}
				else {
					scope.width = undefined;
					scope.height = undefined;
				}
			}
			else if (angular.isObject(value)) {
				scope.width = value.width;
				scope.height = value.height;
			}

			return {
				width:  scope.width,
				height: scope.height,
			};
		});

		// ngModel.$validators.check = (modelValue, viewValue) => {
		// 	let valid = true;
		//
		// 	return valid;
		// };

		// scope.$watchGroup(['width', 'height'], newValues => {
		// 	ngModel.$setViewValue({
		// 		width: newValues[0] === 'N' ? Defaults.KCARDN : parseInt(newValues[0]),
		// 		to:   newValues[1] === 'N' ? Defaults.KCARDN : parseInt(newValues[1])
		// 	});
		// });

		// format text from the user (view to model)
		ngModel?.$parsers.push(value => value);
	},
});

angular.module('app')
	.directive('inputDimensions', inputDimensionsDirective);
